/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EcommerceUserApiSwitchReq
 */
export interface EcommerceUserApiSwitchReq {
    /**
     * 目标启用状态：0停用、1启用。
     * @type {number}
     * @memberof EcommerceUserApiSwitchReq
     */
    enable: number;
}

/**
 * Check if a given object implements the EcommerceUserApiSwitchReq interface.
 */
export function instanceOfEcommerceUserApiSwitchReq(value: object): value is EcommerceUserApiSwitchReq {
    if (!('enable' in value) || value['enable'] === undefined) return false;
    return true;
}

export function EcommerceUserApiSwitchReqFromJSON(json: any): EcommerceUserApiSwitchReq {
    return EcommerceUserApiSwitchReqFromJSONTyped(json, false);
}

export function EcommerceUserApiSwitchReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcommerceUserApiSwitchReq {
    if (json == null) {
        return json;
    }
    return {
        
        'enable': json['enable'],
    };
}

export function EcommerceUserApiSwitchReqToJSON(json: any): EcommerceUserApiSwitchReq {
    return EcommerceUserApiSwitchReqToJSONTyped(json, false);
}

export function EcommerceUserApiSwitchReqToJSONTyped(value?: EcommerceUserApiSwitchReq | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enable': value['enable'],
    };
}

